import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { createGeneratedIntro, createGeneratedPersonality } from '@wix/ambassador-asa-generated-text-v1-generated-text/http';
import { HttpBaseClient } from '../BaseClient/HttpBaseClient';
import { GeneratedTextClientBase } from './GeneratedTextClientBase';
export class GeneratedTextClient extends HttpBaseClient(GeneratedTextClientBase) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "createGeneratedPersonality", createGeneratedPersonality);
    _defineProperty(this, "createGeneratedIntro", createGeneratedIntro);
  }
}
//# sourceMappingURL=GeneratedTextClientHttp.js.map